import { render, staticRenderFns } from "./EducationalStageFilter.vue?vue&type=template&id=6709204b&"
import script from "./EducationalStageFilter.vue?vue&type=script&lang=js&"
export * from "./EducationalStageFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports